import React, {useEffect, useRef, useState, RefObject} from "react";
import {useHistory, useLocation} from "react-router";
import {config} from "../config";
import {useContract} from "../hooks/contract.hooks";
import {CREATE_SIGNAL_ROUTE, SIGNAL_DETAIL_MAP} from "../constants/routes";
import {SignalView} from "@suezenv/signal-widget";
import {useSelector} from "react-redux";
import {RootState} from "../store";
import {GEOSHAPE_92} from "../constants/application";
import {GeographicalLatLng} from "@suezenv/signal-widget/dist/signal-app/type/Address.type";
import {transformSignalViewCsvData} from "../services/csvService";

const SignalViewBridge: React.FC = () => {
    const signalViewRef: RefObject<any>|null = useRef(null);
    const history = useHistory();
    const location = useLocation();
    const contract = useContract();
    const layoutState = useSelector((state: RootState) => state.layoutReducer);
    const userState = useSelector((state: RootState) => state.userReducer);
    const urlSearchParams = new URLSearchParams(location.search);
    const [geoShapeCoordinatesRestriction, setGeoShapeCoordinatesRestriction] = useState<any | null>();

    /**
     * Handles a specific configuration for the view with the map only for the route "SIGNAL_DETAIL_MAP".
     *
     * @see ../constants/routes.ts
     */
    useEffect((): void => {
        const currentRoute = location.pathname;

        if (SIGNAL_DETAIL_MAP === currentRoute) {
            history.replace(location.pathname);
            configureGeoShapeCoordinatesRestriction();
        }
    }, []);

    const handleAddClick = (): void => {
        history.push(CREATE_SIGNAL_ROUTE);
    };

    const displaySignalDetail = (signalId: string): void => {
        history.push(`/signal/${signalId}/detail`);
    };

    const getGeographicalPriority = (): GeographicalLatLng|undefined => {
        let lat = config.geographicalPriority?.split(',')[0]
        let lng = config.geographicalPriority?.split(',')[1]

        if (lat && lng) {
            return {
                lat: Number(lat),
                lng: Number(lng),
            } as GeographicalLatLng;
        }
    }

    const configureGeoShapeCoordinatesRestriction = (): void => {
        const lat = urlSearchParams.get('lat');
        const lng = urlSearchParams.get('lon');

        if (!lat || !lng) {
            return;
        }

        setGeoShapeCoordinatesRestriction([
            [
                [
                    Number(urlSearchParams.get('lon')),
                    Number(urlSearchParams.get('lat')),
                ],
            ],
        ]);
    };

    const preprocessDataBeforeExport = (data: any): any => {
        return transformSignalViewCsvData(data, signalViewRef);
    };

    return (
        <SignalView
            ref={signalViewRef}
            geoServer={{
                url: config.geoserverUrl as string,
                workspace: `UUID-${config.zeusContract}`,
                layer: `UUID-${contract?.id}`,
                authkey: config.geoserverAuthkey as string,
            }}
            addSignal={handleAddClick}
            goSignalDetail={displaySignalDetail}
            geographicalPriority={getGeographicalPriority()}
            signalType={layoutState.signalType}
            user={userState}
            geoShape={GEOSHAPE_92}
            geoShapeCoordinatesRestriction={geoShapeCoordinatesRestriction}
            setGeoShapeCoordinatesRestriction={setGeoShapeCoordinatesRestriction}
            prepareDataForDownloadExport={preprocessDataBeforeExport}
        />
    );
};

export default SignalViewBridge;
